export default class CookielessCityAgent {
    constructor() {
        this.modelName = 'Cookieless City Agent';
        this.modelTip  = '\u{1F512} Privacy-first agent \u2014 your choices boost digital safety.';
        this.state = {
            population:  0.5,
            environment: 0.5,
            privacy:     1.0,
            happiness:   0.5,
            economy:     0.5,
            security:    0.5
        };
    }
    update(action) {
        switch (action) {
            case 0:
                this.state.privacy  = Math.min(1, this.state.privacy  + 0.1);
                this.state.economy  = Math.max(0, this.state.economy  - 0.05);
                break;
            case 1:
                this.state.economy  = Math.min(1, this.state.economy  + 0.1);
                this.state.privacy  = Math.max(0, this.state.privacy  - 0.05);
                break;
            case 2:
                this.state.happiness    = Math.min(1, this.state.happiness    + 0.1);
                this.state.environment  = Math.min(1, this.state.environment  + 0.1);
                break;
            default:
                Object.keys(this.state).forEach(k => {
                    this.state[k] = Math.max(0, Math.min(1, this.state[k] + (Math.random() - 0.5) * 0.01));
                });
        }
    }
    getStateArray() {
        return [
            this.state.population,  this.state.environment,
            this.state.privacy,     this.state.happiness,
            this.state.economy,     this.state.security
        ];
    }
}
